<template>
    <el-dialog @close='closeDialog' :title="titleText" :visible.sync="dialogVisible">
        <div class="SelectClassPop_box">
            <el-tree :data="data" node-key="id" :default-expand-all="true" @node-click="handleNodeClick" :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{node, data}">
                    <span style="margin-right: 12px;">{{node.label}}</span>
                    <span style="color: #909399;">{{data.datacount}}</span>
                </span>
            </el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureBtn()">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'CopyPop',
    data() {
        return {
            titleText: '选择分类',
            dialogVisible: false,
            data: [],
            classId: '',
            className: ''
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog(val) {
            this.data = val[0].children
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        handleNodeClick(data) {
            // console.log(data)
            this.classId = data.id
            this.className = data.label
        },
        // 确定按钮
        sureBtn() {
            if(this.classId === '') {
                this.$message.error('请选择分类')
            } else {
                this.closeDialog()
                this.$emit('getClassInfo', this.classId, this.className)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .SelectClassPop_box {
        height: 280px;
        overflow: auto;
        .el-tree-node__content {
            height: 40px;
        }
    }
    .SelectClassPop_box::-webkit-scrollbar {
        width: 4px;
    }
    .SelectClassPop_box::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background:rgba(229,229,229,1);
    }
    .SelectClassPop_box::-webkit-scrollbar-track {
        border-radius: 2px;
        background: #fff;
    }
    .el-tree .el-tree-node.is-current > .el-tree-node__content {
        // background-color: #FAFAFA;
        color: #409EFF;
    }
</style>
